import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { Dropdown } from 'primereact/dropdown'
import { Button } from 'primereact/button'
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { LoadingSpinner } from '../../../components/loadingSpinner/LoadingSpinner'
import { Page } from '../../../components/page/Page'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'
import { AgendarRelatorioDialog } from '../../../components/agendamentoRelatorio/AgendarRelatorioDialog'
import {
  getRelatorioAgendavel,
  isRelatorioAgendavel,
} from '../../../components/agendamentoRelatorio/relatoriosAgendaveis'
import { getTelaDinamicaAgendavel } from '../../../components/agendamentoRelatorio/telaDinamicaAgendavel'
import { textoAgendamento } from '../../../components/agendamentoRelatorio/textos'
import {
  abrirAbaEmBranco,
  fecharAba,
  mensagemDeErro,
  mostrarNaAba,
} from '../../../components/agendamentoRelatorio/agendamentoRelatorio.utils'
import { carregar, salvar, visualizar } from '../../../services/api-agendamento-relatorio'
import { messageActions } from '../../../store/message'
import { routes } from '../../../constants'
import utils, { getMessage } from '../../../utils/index'
import {
  changeFavorito,
  componentDidMount,
  componentDidUpdate,
  loadFavorito,
  onColumnReorder,
  onColumnToggle,
  onPage,
  onSort,
} from '../../../utils/listPageContainerUtils'
import { actions, BASE_PATH } from '../agendamentoRelatorio.actions'
import { AgendamentoRelatorioList } from './AgendamentoRelatorioList'
import '../../../index.scss'
import '../../../components/agendamentoRelatorio/AgendarRelatorioDialog.scss'

const mapStateToProps = (state) => {
  const s = state.crudAgendamentoRelatorioState
  return {
    showHideColumns: s.showHideColumns,
    messages: s.messages,
    columns: s.columns,
    records: s.records,
    isLoadingRecords: s.isLoadingRecords,
    first: s.index,
    rows: s.max,
    totalRecords: s.count,
    sortField: s.sortField,
    order: s.sortOrder,
    selectedFilters: s.selectedFilters,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.setType(null))
      dispatch(actions.applyFilter(filterParams))
    },
    changeFilter: (column, e) => {
      const target = e.target
      const campo = column.fieldJoin ? column.fieldJoin : target.name
      dispatch(actions.setSelectedFilters(campo, target.value, column.relacionamento, column.field))
      setTimeout(() => {
        dispatch(actions.executeFilter(`${BASE_PATH}/all`))
      }, 400)
    },
    load: () => dispatch(actions.load()),
    setColumns: (columns) => dispatch(actions.loadColumns(columns)),
    loadFavorito: (menu) => dispatch(actions.loadFavorito(menu)),
    removeFavorito: (menu) => dispatch(actions.removeFavorito(menu)),
    adicionarFavorito: (menu) => dispatch(actions.adicionarFavorito(menu)),
    clearSelectedFilters: () => dispatch(actions.clearSelectedFilters()),
    mostrar: (mensagem, tipo) => dispatch(messageActions.showMessages([mensagem], tipo)),
  }
}

/**
 * Relatorios agendados (PHOENIX-106): so lista. O agendamento nasce no botao Agendar de cada relatorio; aqui da
 * para editar (mesmo dialogo), ver o relatorio com as datas de hoje e ativar/desativar. Sem "Novo" e sem excluir.
 */
class AgendamentoRelatorioListPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.dataTableRef = React.createRef()
    this.showHideColumns = []
    this.showCSVButton = false
    // sem importacao: o agendamento nasce so no botao Agendar do relatorio
    this.hideBtnImportacao = true
    this.showColumnButton = false
    this.state = {
      dadosFavorito: null,
      favorito: 0,
      emEdicao: null,
      ocupado: false,
    }
    this.onColumnToggle = this.onColumnToggle.bind(this)
  }

  onColumnToggle(event) {
    onColumnToggle(event, this)
  }

  onColReorder(e, colunasAtuais) {
    onColumnReorder(e, colunasAtuais, this)
  }

  loadFavorito() {
    loadFavorito(this, actions)
  }

  changeFavorito() {
    changeFavorito(this, actions)
  }

  componentDidMount() {
    componentDidMount(this)
  }

  componentDidUpdate(prevProps, prevState) {
    componentDidUpdate(this, prevProps, prevState)
  }

  onPage = (e) => {
    onPage(this, e)
  }

  onSort = (e) => {
    onSort(this, e)
  }

  // textos ja carregados no reducer (state.messages): o helper sem eles refaria o parse do dicionario a cada celula
  texto = (chave) => textoAgendamento(chave, this.props.messages)

  /**
   * A linha da listagem vem com a projecao reduzida: as acoes trabalham sobre o registro completo. Falha ao carregar
   * e falha da acao (salvar, ver relatorio) tem mensagens diferentes.
   */
  comAgendamento = async (oid, acao, aoFalhar) => {
    this.setState({ ocupado: true })
    try {
      let agendamento
      try {
        agendamento = (await carregar(oid)).data
      } catch (e) {
        this.props.mostrar(mensagemDeErro(e, this.texto('erro.carregar')), 'error')
        if (aoFalhar) {
          aoFalhar()
        }
        return
      }
      try {
        await acao(agendamento)
      } catch (e) {
        this.props.mostrar(mensagemDeErro(e, this.texto('erro.operacao')), 'error')
        if (aoFalhar) {
          aoFalhar()
        }
      }
    } finally {
      this.setState({ ocupado: false })
    }
  }

  // a linha da listagem nao diz se e tela dinamica (projecao sem o documento): so o registro carregado diz
  editar = (rowData) => {
    this.comAgendamento(rowData.oid, (agendamento) => {
      // relatorio sem dialogo (tela fixa fora do registro): avisa em vez de nao abrir nada
      if (!agendamento.oidDocumento && !isRelatorioAgendavel(agendamento.path)) {
        this.props.mostrar(this.texto('erro.naoEditavel'), 'warn')
        return
      }
      this.setState({ emEdicao: agendamento })
    })
  }

  // a aba abre no clique (gesto do usuario); aberta so depois das duas chamadas, o navegador bloqueia como pop-up
  verRelatorio = (rowData) => {
    const janela = abrirAbaEmBranco()
    this.comAgendamento(
      rowData.oid,
      (agendamento) => visualizar(agendamento).then(({ data }) => mostrarNaAba(janela, data)),
      () => fecharAba(janela)
    )
  }

  alternarAtivo = (rowData) =>
    this.comAgendamento(rowData.oid, (agendamento) =>
      salvar({ ...agendamento, ativo: !agendamento.ativo }).then(() => this.props.load())
    )

  buildHeader = () => {
    return (
      <DefaultToolBar
        listPageContainer={this}
        title={getMessage(this.props.messages, 'agendamentorelatorio.label.agendamentosrelatorio')}
      />
    )
  }

  // Ativo e Ultimo status filtram por lista; o ultimo status e traduzido no back (AgendamentoRelatorioService)
  opcoesFiltro = {
    ativo: [
      { label: this.texto('todos'), value: '' },
      { label: this.texto('sim'), value: true },
      { label: this.texto('nao'), value: false },
    ],
    ultimoStatus: [
      { label: this.texto('todos'), value: '' },
      { label: this.texto('status.enviado'), value: 1 },
      { label: this.texto('status.erro'), value: 2 },
      { label: this.texto('status.semDados'), value: 3 },
    ],
  }

  fieldFilter = (column) => {
    if (!column.filter) {
      return null
    }
    const opcoes = this.opcoesFiltro[column.field]
    if (opcoes) {
      const selecionado = (this.props.selectedFilters || []).find((f) => f.campo === column.field)
      return (
        <Dropdown
          style={{ width: '100%', minWidth: '10px' }}
          name={column.field}
          value={selecionado ? selecionado.valor : ''}
          options={opcoes}
          onChange={(e) => this.props.changeFilter(column, e)}
        />
      )
    }
    return (
      <InputText
        style={{ width: '100%' }}
        name={column.field}
        value={this.props.selectedFilters[column.field]}
        onChange={(e) => this.props.changeFilter(column, e)}
      />
    )
  }

  formatColumn = (rowData, column) => utils.format(rowData, column)

  relatorio = (rowData) => {
    const registro = getRelatorioAgendavel(rowData.path, this.props.messages)
    return registro ? registro.descricao : rowData.path
  }

  ativo = (rowData) => this.texto(rowData.ativo ? 'sim' : 'nao')

  // como nas outras listagens, o codigo abre a edicao (aqui, o dialogo)
  oid = (rowData) => (
    <Link
      to={routes.PATH_AGENDAMENTOS_RELATORIO}
      onClick={(e) => {
        e.preventDefault()
        if (!this.state.ocupado) {
          this.editar(rowData)
        }
      }}
    >
      {rowData.oid}
    </Link>
  )

  acoes = (rowData) => {
    return (
      <div className="agendamento-relatorio-acoes">
        <Button
          icon="pi pi-pencil"
          tooltip={this.texto('editar')}
          onClick={() => this.editar(rowData)}
          disabled={this.state.ocupado}
        />
        <Button
          icon="pi pi-eye"
          className="p-button-secondary"
          tooltip={getMessage(this.props.messages, 'agendamentorelatorio.label.visualizar')}
          onClick={() => this.verRelatorio(rowData)}
          disabled={this.state.ocupado}
        />
        <Button
          icon={rowData.ativo ? 'pi pi-pause' : 'pi pi-play'}
          className={rowData.ativo ? 'p-button-warning' : 'p-button-success'}
          tooltip={this.texto(rowData.ativo ? 'desativar' : 'ativar')}
          onClick={() => this.alternarAtivo(rowData)}
          disabled={this.state.ocupado}
        />
      </div>
    )
  }

  // muitas colunas cortam o texto: o valor inteiro aparece ao passar o mouse
  comTitle = (valorDaCelula) => (rowData, column) => {
    const valor = valorDaCelula(rowData, column)
    return <div title={valor}>{valor}</div>
  }

  // datas com hora e o status por extenso nao cabem na largura dividida por igual
  classesLargura = {
    proximaExecucao: 'agendamento-relatorio-coluna-data',
    dtUltimaExecucao: 'agendamento-relatorio-coluna-data',
    ultimoStatus: 'agendamento-relatorio-coluna-status',
  }

  defineColumns = () => {
    const visibleColumns = this.props.columns.filter((col) => col.visible)
    return visibleColumns.map((col) => {
      col.showFilterMenuOptions = false
      col.showClearButton = false
      col.showFilterMenu = false

      let body
      if (col.field === 'oid') {
        body = this.oid
      } else if (col.field === 'acoes') {
        body = this.acoes
      } else if (col.field === 'path') {
        body = this.comTitle(this.relatorio)
      } else if (col.field === 'ativo') {
        body = this.ativo
      } else if (col.fieldFormatter) {
        body = this.comTitle(this.formatColumn)
      } else {
        body = this.comTitle((rowData) => rowData[col.field])
      }
      const classeLargura = this.classesLargura[col.field]
      return (
        <Column
          {...col}
          header={col.messageKey ? getMessage(this.props.messages, col.messageKey) : col.header}
          key={col.field}
          body={body}
          headerClassName={classeLargura}
          bodyClassName={classeLargura}
          filterHeaderClassName={classeLargura}
          filterHeaderStyle={this.opcoesFiltro[col.field] ? { overflow: 'visible' } : undefined}
          sortField={col.columnSortField}
          filterElement={this.fieldFilter(col)}
        />
      )
    })
  }

  buildContent = () => {
    return (
      <AgendamentoRelatorioList
        {...this.props}
        dataTableRef={(el) => (this.dataTableRef = el)}
        onColReorder={(e) => this.onColReorder(e, this.showHideColumns)}
        onPage={this.onPage}
        onSort={this.onSort}
        columns={this.defineColumns()}
      />
    )
  }

  renderDialogo = () => {
    const agendamento = this.state.emEdicao
    if (!agendamento) {
      return null
    }
    const fixo = agendamento.oidDocumento ? null : getRelatorioAgendavel(agendamento.path, this.props.messages)
    const registro = agendamento.oidDocumento
      ? getTelaDinamicaAgendavel({
          oid: agendamento.oidDocumento,
          nome: agendamento.nomeDocumento,
          nomeRelatorio: agendamento.path,
          parametros: agendamento.parametrosDocumento,
        })
      : fixo && { ...fixo, relatorio: { path: agendamento.path, descricao: fixo.descricao } }
    if (!registro) {
      return null
    }
    return (
      <AgendarRelatorioDialog
        visible={true}
        onHide={() => this.setState({ emEdicao: null })}
        relatorio={registro.relatorio}
        camposData={registro.camposData}
        filtrosTela={{}}
        agendamento={agendamento}
        EditorFiltros={registro.EditorFiltros}
        onSaved={() => {
          this.props.mostrar(this.texto('salvo'), 'success')
          this.props.load()
        }}
      />
    )
  }

  render() {
    if (this.props.columns && this.props.columns.length > 0) {
      return (
        <React.Fragment>
          <Page header={this.buildHeader()} content={this.buildContent()} loading={this.props.isLoadingRecords} />
          {this.renderDialogo()}
        </React.Fragment>
      )
    }
    return <LoadingSpinner />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgendamentoRelatorioListPageContainer)
